import { render, staticRenderFns } from "./NewsContentTypes.vue?vue&type=template&id=cac9453e"
import script from "./NewsContentTypes.js?vue&type=script&lang=js&external"
export * from "./NewsContentTypes.js?vue&type=script&lang=js&external"
import style0 from "./NewsContentTypes.vue?vue&type=style&index=0&id=cac9453e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports